/* AII — Richiesta contatto associato.
   - Validazione client (Nome, Cognome, Telefono, Email, Associato, Privacy) con errori inline + aria-invalid + focus.
   - Notifica email (solo): POST best-effort a FormSubmit AJAX (stesso pattern di aii-docs-gate.js).
   - Pre-selezione associato: ascolta l'evento 'aii:contatto-preselect' emesso dalle card.
   Caricato da sections/aii-contatto-associato.liquid. */
(function () {
  'use strict';

  var ENDPOINT = 'https://formsubmit.co/ajax/info@aimprenditori.it';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(section) {
    if (!section || section.dataset.aiiCaReady === '1') return;
    section.dataset.aiiCaReady = '1';

    var form = section.querySelector('[data-aii-ca-form]');
    var success = section.querySelector('[data-aii-ca-success]');
    var selectEl = section.querySelector('#aii-ca-associato');
    if (!form || !selectEl) return;

    var fields = {
      nome: section.querySelector('#aii-ca-nome'),
      cognome: section.querySelector('#aii-ca-cognome'),
      telefono: section.querySelector('#aii-ca-phone'),
      email: section.querySelector('#aii-ca-email'),
      associato: selectEl,
      privacy: section.querySelector('#aii-ca-privacy')
    };
    var motivoEl = section.querySelector('#aii-ca-motivo');
    var marketingEl = section.querySelector('#aii-ca-marketing');

    // Il `sort: 'card_id'` di Liquid è lessicografico (1,10,11,...,2): riordina numericamente le option
    // per card_id mantenendo il placeholder (senza data-cid) in cima.
    (function sortOptionsByCardId() {
      var opts = Array.prototype.slice.call(selectEl.querySelectorAll('option[data-cid]'));
      opts.sort(function (a, b) {
        return (parseInt(a.getAttribute('data-cid'), 10) || 0) - (parseInt(b.getAttribute('data-cid'), 10) || 0);
      });
      opts.forEach(function (o) { selectEl.appendChild(o); });
    })();

    // ----- Helpers errori -----
    function errEl(key) { return section.querySelector('#aii-ca-' + key + '-err'); }

    function setError(input, key, msg) {
      var e = errEl(key);
      if (e) { e.textContent = msg; e.hidden = false; }
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        if (key === 'privacy') {
          var wrap = input.closest('.aii-contact__privacy');
          if (wrap) wrap.classList.add('is-invalid');
        } else {
          input.classList.add('is-invalid');
        }
      }
    }

    function clearError(input, key) {
      var e = errEl(key);
      if (e) { e.textContent = ''; e.hidden = true; }
      if (input) {
        input.removeAttribute('aria-invalid');
        input.classList.remove('is-invalid');
        var wrap = input.closest('.aii-contact__privacy');
        if (wrap) wrap.classList.remove('is-invalid');
      }
    }

    // Pulisci l'errore quando l'utente corregge
    ['nome', 'cognome', 'telefono', 'email'].forEach(function (k) {
      if (fields[k]) fields[k].addEventListener('input', function () { clearError(fields[k], errKey(k)); });
    });
    if (fields.associato) fields.associato.addEventListener('change', function () { clearError(fields.associato, 'associato'); });
    if (fields.privacy) fields.privacy.addEventListener('change', function () { clearError(fields.privacy, 'privacy'); });

    // map nome->phone id mismatch (telefono usa id #aii-ca-phone => err id 'phone')
    function errKey(k) { return k === 'telefono' ? 'phone' : k; }

    function validate() {
      var firstInvalid = null;
      function fail(input, key, msg) {
        setError(input, key, msg);
        if (!firstInvalid) firstInvalid = input;
      }

      var nome = (fields.nome.value || '').trim();
      var cognome = (fields.cognome.value || '').trim();
      var telefono = (fields.telefono.value || '').trim();
      var email = (fields.email.value || '').trim();
      var associato = fields.associato.value || '';

      clearError(fields.nome, 'nome');
      clearError(fields.cognome, 'cognome');
      clearError(fields.telefono, 'phone');
      clearError(fields.email, 'email');
      clearError(fields.associato, 'associato');
      clearError(fields.privacy, 'privacy');

      if (!nome) fail(fields.nome, 'nome', 'Inserisci il nome.');
      if (!cognome) fail(fields.cognome, 'cognome', 'Inserisci il cognome.');
      if (!telefono) fail(fields.telefono, 'phone', 'Inserisci un recapito telefonico.');
      if (!email) {
        fail(fields.email, 'email', "Inserisci l'indirizzo email.");
      } else if (!EMAIL_RE.test(email)) {
        fail(fields.email, 'email', 'Inserisci un indirizzo email valido.');
      }
      if (!associato) fail(fields.associato, 'associato', "Seleziona l'associato da contattare.");
      if (!fields.privacy.checked) fail(fields.privacy, 'privacy', "Devi autorizzare il trattamento dei dati.");

      return firstInvalid;
    }

    // ----- Notifica email (best-effort, sempre) -----
    function notify(data) {
      try {
        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            _subject: 'Richiesta contatto associato — ' + (data.associatoNome || ''),
            _template: 'table',
            Nome: data.nome,
            Cognome: data.cognome,
            Telefono: data.telefono,
            Email: data.email,
            Associato: data.associatoNome,
            Motivazione: data.motivo || '—',
            'Consenso marketing': data.marketing ? 'Sì' : 'No',
            Pagina: 'i-nostri-associati'
          })
        }).catch(function (err) { console.warn('[AII] Notifica contatto non inviata:', err); });
      } catch (err) {
        console.warn('[AII] Notifica contatto non inviata:', err);
      }
    }

    function showSuccess() {
      form.style.display = 'none';
      if (success) {
        success.classList.add('is-visible');
        // Forza l'annuncio del live region (era display:none): ri-scrive il testo dopo che è visibile.
        var msgEl = success.querySelector('[data-aii-ca-success-msg]');
        if (msgEl) {
          var msg = msgEl.textContent;
          msgEl.textContent = '';
          setTimeout(function () { msgEl.textContent = msg; }, 60);
        }
        try { success.focus({ preventScroll: true }); } catch (e) { /* no-op */ }
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var firstInvalid = validate();
      if (firstInvalid) {
        try { firstInvalid.focus({ preventScroll: true }); } catch (err) { /* no-op */ }
        try { firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { /* no-op */ }
        return;
      }

      var selectedOpt = fields.associato.options[fields.associato.selectedIndex];
      var data = {
        nome: fields.nome.value.trim(),
        cognome: fields.cognome.value.trim(),
        telefono: fields.telefono.value.trim(),
        email: fields.email.value.trim(),
        associatoHandle: fields.associato.value,
        associatoNome: selectedOpt ? selectedOpt.textContent.trim() : fields.associato.value,
        motivo: motivoEl ? motivoEl.value.trim() : '',
        marketing: !!(marketingEl && marketingEl.checked)
      };

      notify(data); // solo notifica email (la creazione automatica del cliente è stata rimossa)

      showSuccess();
      form.reset();
    });

    // ----- Pre-selezione da card (evento emesso da associati-grid) -----
    function preselect(handle) {
      if (!handle) return;
      var opt = selectEl.querySelector('option[value="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
      if (opt) {
        selectEl.value = handle;
        clearError(selectEl, 'associato');
        try { selectEl.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { /* no-op */ }
      }
    }

    document.addEventListener('aii:contatto-preselect', function (e) {
      if (e && e.detail) preselect(e.detail.handle);
    });
  }

  function boot() {
    document.querySelectorAll('[data-aii-ca]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
